export default function validate(values, langCode) {
    const errors = {};
    const translation = values?.translations?.find(t => t.langCode === langCode);

    if (!translation) {
      errors.message = "Translation not found for the selected language";
      return errors;
    }

    if (!translation.name || translation.name === "") {
      errors.name = "Please enter the recommender's name";
    }

    if (
      !translation.profession || 
      translation.profession.length === 0 || 
      (translation.profession.some((profession) => !profession.professionName || profession.professionName.trim() === ""))
    ) {
      errors.profession = "Please provide the profession of the recommender";
    }

    if (
      // An entry is a book or a series; either way it needs a name to show.
      translation.recommendedBooks.some((recommend) => !(recommend.bookName || recommend.seriesName || "").trim()) || 
      translation.recommendedBooks.length === 0
    ) {
      errors.recommendedBooks = "Please provide the books or series the recommender recommends";
    }

    if (
      translation.recommendedGenres.some((genre) => !genre.genreName || genre.genreName.trim() === "") || 
      translation.recommendedGenres.length === 0
    ) {
      errors.recommendedGenres = "Please provide recommended genres by the recommender";
    }

    if (!values.mediaLink || Object.keys(values.mediaLink).length === 0) {
      errors.mediaLink = "Please provide any of the one Social media link";
    }

    if (!translation.about || translation.about === "") {
      errors.about = "Please write about the recommender";
    }

    // if (!values.image || Object.keys(values.image).length === 0 || !values.image.uploadedImageUrl) {
    //   errors.image = "Please upload an image";
    // }

    if (Object.keys(errors).length > 0) {
      errors.message = "Form validation failed";
    }

    return errors;
};